import { render } from "./CustomFileUpload.vue?vue&type=template&id=adafa2b6"
import script from "./CustomFileUpload.vue?vue&type=script&lang=js"
export * from "./CustomFileUpload.vue?vue&type=script&lang=js"

import "./CustomFileUpload.vue?vue&type=style&index=0&id=adafa2b6&lang=css"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\40\\s\\PASVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__